import { partnerImagesApi } from 'legacy/lut/classes/services/api/PartnerImagesApi'
import { DragNDropFileUploader, IFileSettings } from 'legacy/lut/library/dragNDrop'
import React from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { saveFile } from 'core/classes/helpers/saveFiles'

import { GalleryImage } from './Gallery/Image'

import styles from './Gallery.module.scss'

interface IProps {
  onChange: () => void
  imageType: string
  partnerId: string
  images: IObjectAny[]
}
export const Gallery = (props: IProps) => {
  const [isAdd, setIsAdd] = React.useState<boolean>(false)
  const [fileLoader, setfileLoader] = React.useState<IForm | undefined>(undefined)
  const [value, setValue] = React.useState('')
  const [isFileUpload, setIsFileUpload] = React.useState(false)
  const [loaded, setLoaded] = React.useState<boolean>(false)

  const addImage = async () => {
    setIsAdd(true)
  }

  const handlePictureChange = (files: IFileSettings[]) => {
    files.forEach((item) => {
      setfileLoader({
        formId: 504,
        formCode: 'spif-1504',
        fieldName: 'Image',
        file: item.file,
        fileName: item.file.name,
      })
      setValue(item.value)
      setIsFileUpload(true)
    })
  }

  const getPreviewSrc = (): any => {
    return value
  }

  const save = async () => {
    setLoaded(true)
    if (isFileUpload && fileLoader) {
      await saveFile({
        formId: fileLoader.formId,
        formCode: fileLoader.formCode,
        fieldName: fileLoader.fieldName,
        models: [
          {
            ImageType: props.imageType,
            PartnerId: props.partnerId,
            EntryId: 0,
            file: fileLoader.file,
          },
        ],
      })
      setfileLoader(undefined)
    } else {
      await partnerImagesApi.setPartnerImage(
        {
          EntryId: 0,
          Image: null,
          ImageType: props.imageType,
          PartnerId: props.partnerId,
        },
        'create'
      )
    }
    setIsAdd(false)
    setLoaded(false)
    setValue('')
    props.onChange()
  }

  const addImageBtn = () => {
    return (
      <div className={styles.add}>
        <p className={styles.addText}>add a new image</p>
        <Button
          className={styles.addBtnWrapper}
          iconButton={'kbase kbase-add'}
          onClick={addImage}
        />
      </div>
    )
  }

  const selectImage = () => {
    return (
      <div>
        <DragNDropFileUploader changeFileLoader={handlePictureChange} acceptedFormats={'image/*'} />
        <img
          src={getPreviewSrc()}
          style={{
            width: `100px`,
          }}
          alt=""
        />
        <div className={styles.actionBox}>
          {loaded && (
            <div className={styles.loaderWrapper}>
              <Loader className={styles.loader} />
            </div>
          )}
          <Button
            iconButton={'kbase kbase-save'}
            variant={'text'}
            disabled={value ? false : true}
            onClick={save}
          />
          <Button
            iconButton={'kbase kbase-close'}
            variant={'text'}
            color={'grey'}
            onClick={() => {
              setIsAdd(false)
              setValue('')
            }}
          />
        </div>
      </div>
    )
  }

  return (
    <div>
      {props.images &&
        props.images
          .filter((el: any) => el.ImageType === props.imageType)
          .map((el: any, index: number) => <GalleryImage key={index} item={el} {...props} />)}
      {props.images
        ? props.images.filter((el: any) => el.ImageType === props.imageType).length < 5 &&
          ((props.images.filter((item) => item.ImageType === 'Listing').length === 0 &&
            props.imageType === 'Listing') ||
            props.imageType === 'Gallery') &&
          (!isAdd ? addImageBtn() : selectImage())
        : !isAdd
          ? addImageBtn()
          : selectImage()}
    </div>
  )
}
